import { useEffect, useState } from 'react'

import InputLayout from '../InputLayout/InputLayout'

import './InputDate.scss'

import Typography from 'components/Typography/Typography'
import { days, months, years } from './dates'

// TODO: Add intl to buttons
//TODO touched doesn't work

const InputDate = ({
    color = 'blue',
    disabled,
    error,
    id,
    label,
    placeholder,
    name,
    onBlur,
    onHandle,
    touched,
    value,
    ...props
}) => {
    const [dateValue, setDateValue] = useState('2000-01-01')

    const handleSetDay = (value, type) => {
        const [YYYY, MM, DD] = dateValue.split('-')
        if (type === 'DD') {
            const newValue = `${YYYY}-${MM}-${value}`
            setDateValue(newValue)
        }
        if (type === 'MM') {
            const newValue = `${YYYY}-${value}-${DD}`
            setDateValue(newValue)
        }
        if (type === 'YYYY') {
            const newValue = `${value}-${MM}-${DD}`
            setDateValue(newValue)
        }
    }

    useEffect(() => {
        onHandle(dateValue)
    }, [dateValue])

    return (
        <InputLayout label={label} error={error} color={color} touched={touched} className={'input-date'}>
            <input
                type="date"
                value={dateValue}
                id={id}
                name={name}
                onChange={(e) => {
                    setDateValue(e.target.value)
                }}
                className="d-none"
            />

            <div className="date-fields">
                <div className="date-field">
                    <div className="label">
                        <Typography variant={'p'}>Den</Typography>
                    </div>

                    <select
                        className="input"
                        value={dateValue.split('-')[3]}
                        onChange={(e) => handleSetDay(e.target.value, 'DD')}
                    >
                        {days.map((day) => (
                            <option key={day} value={day}>
                                {day}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="date-field">
                    <div>
                        <Typography variant={'p'}>Měsíc</Typography>
                    </div>
                    <select
                        className="input"
                        value={dateValue.split('-')[1]}
                        onChange={(e) => handleSetDay(e.target.value, 'MM')}
                    >
                        {months.map((month) => (
                            <option key={month} value={month}>
                                {month}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="date-field">
                    <div>
                        <Typography variant={'p'}> Rok </Typography>
                    </div>
                    <select
                        className="input"
                        value={dateValue.split('-')[0]}
                        onChange={(e) => handleSetDay(e.target.value, 'YYYY')}
                    >
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </InputLayout>
    )
}

export default InputDate
